import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

// Wraps any input with a label, optional hint, and error slot.
// One component means labels, spacing, and error styling stay identical
// across all six steps.
export const Field = ({ label, htmlFor, hint, error, required, extracted, children }) => (
  <div className={`field ${error ? 'field--error' : ''} ${extracted ? 'field--extracted' : ''}`}>
    <label className="field__label" htmlFor={htmlFor}>
      {label}
      {required && (
        <span className="field__required" aria-hidden="true">
          *
        </span>
      )}
      {extracted && (
        <span className="field__extracted-tag" title="Filled from your uploaded PDF — please check">
          from PDF
        </span>
      )}
    </label>

    {children}

    {error ? (
      <span className="field__error" role="alert">
        {error}
      </span>
    ) : (
      hint && <span className="field__hint">{hint}</span>
    )}
  </div>
);

Field.propTypes = {
  label: PropTypes.string.isRequired,
  htmlFor: PropTypes.string,
  hint: PropTypes.string,
  error: PropTypes.string,
  required: PropTypes.bool,
  extracted: PropTypes.bool,
  children: PropTypes.node.isRequired
};

Field.propTypes = {
  label: PropTypes.string.isRequired,
  htmlFor: PropTypes.string,
  hint: PropTypes.string,
  error: PropTypes.string,
  required: PropTypes.bool,
  children: PropTypes.node.isRequired
};

export const TextField = ({ id, error, ...rest }) => (
  <input id={id} className={`control ${error ? 'control--error' : ''}`} {...rest} />
);

TextField.propTypes = {
  id: PropTypes.string,
  error: PropTypes.string
};

export const SelectField = ({ id, error, options, placeholder, ...rest }) => (
  <div className="control-wrap">
    <select id={id} className={`control ${error ? 'control--error' : ''}`} {...rest}>
      {placeholder && <option value="">{placeholder}</option>}
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
    <svg className="control-wrap__chevron" viewBox="0 0 12 12" aria-hidden="true">
      <path
        d="M2.5 4.5L6 8l3.5-3.5"
        stroke="currentColor"
        strokeWidth="1.6"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);

SelectField.propTypes = {
  id: PropTypes.string,
  error: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.any, label: PropTypes.string }))
    .isRequired
};

export const TextAreaField = ({ id, error, ...rest }) => (
  <textarea
    id={id}
    className={`control control--area ${error ? 'control--error' : ''}`}
    {...rest}
  />
);

TextAreaField.propTypes = {
  id: PropTypes.string,
  error: PropTypes.string
};
